import React, { useEffect, useState } from 'react'
import { Flex } from 'antd'
import TextArea from 'antd/es/input/TextArea'
import {
    useFetchTextSubmissionDetailsQuery,
    useUpdateTextSubmissionMutation,
} from '../../../../../../store/apis/submission.api'
import Text from 'antd/es/typography/Text'
import { fetchTextSubmissionDetailsSelectors } from '../../../../../../store/apis/utils/selectors/submission.api.selectors'

const useSyncFeedback = feedbackFromStore => {
    const [feedback, setFeedback] = useState('')

    useEffect(() => {
        setFeedback(feedbackFromStore || '')
    }, [feedbackFromStore])

    return [feedback, setFeedback]
}

const useDisappearingSavedStatus = updateResult => {
    const [savedStatus, setSavedStatus] = useState('')

    useEffect(() => {
        if (updateResult.isSuccess) {
            setSavedStatus('Saved')
            const timer = setTimeout(() => setSavedStatus(''), 3000)
            return () => clearTimeout(timer)
        }
    }, [updateResult])

    return savedStatus
}

const OverallFeedbackInput = ({ submissionId }) => {
    const { data: feedbackFromStore } = useFetchTextSubmissionDetailsQuery(
        { submissionId },
        { selectFromResult: result => fetchTextSubmissionDetailsSelectors.feedback(result) },
    )

    const [feedback, setFeedback] = useSyncFeedback(feedbackFromStore)
    const [updateTextSubmission, updateTextSubmissionResult] = useUpdateTextSubmissionMutation()

    const savedStatus = useDisappearingSavedStatus(updateTextSubmissionResult)

    const handleBlur = () => {
        const feedbackHasChanged = feedback !== feedbackFromStore
        if (feedback && feedbackHasChanged) updateTextSubmission({ id: submissionId, feedback })
    }

    const handleChange = event => {
        setFeedback(event.target.value)
    }

    const feedbackChanged = feedback !== feedbackFromStore

    const status = (() => {
        if (updateTextSubmissionResult.isLoading) return 'Saving...'
        if (updateTextSubmissionResult.isError) return updateTextSubmissionResult.error
        if (feedbackChanged) return 'Edited'
        return savedStatus
    })()

    return (
        <label className='d-flex-column'>
            <Flex justify='space-between' className='f-width'>
                <Text className='mb-8'>Overall feedback</Text>
                {status && <Text type='secondary'>{status}</Text>}
            </Flex>
            <TextArea
                value={feedback}
                onChange={handleChange}
                onBlur={handleBlur}
                autoSize
                placeholder='Enter overall feedback for this submission'
            />
        </label>
    )
}

export default OverallFeedbackInput
